import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'accent';
  fullWidth?: boolean;
  showIcon?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  fullWidth = false,
  showIcon = true
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center gap-2 font-heading font-semibold text-lg md:text-xl rounded-full transition-all duration-300 hover:scale-[1.03] active:scale-[0.98] shadow-soft overflow-hidden group';
  const variants = {
    primary: 'bg-primary text-white hover:shadow-glow-primary hover:bg-gradient-to-r hover:from-primary hover:to-primary-dark',
    accent: 'bg-accent text-dark hover:bg-accent-dark'
  };
  const widthClass = fullWidth ? 'w-full px-8 py-5' : 'px-10 py-5';
  return <a href="#checkout" className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} data-id="element-46">
      <span className="relative z-10" data-id="element-47">{children}</span>
      {showIcon && <ArrowRight className="w-5 h-5 md:w-6 md:h-6 group-hover:translate-x-1 transition-transform relative z-10" data-id="element-48" />}
    </a>;
}